import { deleteMethodWithToken } from 'services/apiServices';
import url from 'services/urls.json';
import { ClearTokenRedirectLogin } from 'utils/general';

// Action Types
export const DELETE_CUSTOMER_SUPERADMIN = 'DELETE_CUSTOMER_SUPERADMIN';
export const DELETE_CUSTOMER_SUPERADMIN_SUCCESS =
  'DELETE_CUSTOMER_SUPERADMIN_SUCCESS';
export const DELETE_CUSTOMER_SUPERADMIN_FAILURE =
  'DELETE_CUSTOMER_SUPERADMIN_FAILURE';

// Action Creators
export const fetchDeleteCustomerSuperAdmin = () => ({
  type: DELETE_CUSTOMER_SUPERADMIN,
});

export const fetchDeleteCustomerSuperAdminSuccess = (data) => ({
  type: DELETE_CUSTOMER_SUPERADMIN_SUCCESS,
  payload: data,
});

export const fetchDeleteCustomerSuperAdminFailure = (error) => ({
  type: DELETE_CUSTOMER_SUPERADMIN_FAILURE,
  payload: error,
});

// Thunk Function
export const deleteCustomerSuperAdminCallAPI = (data, external = {}) => {
  return async (dispatch) => {
    dispatch(fetchDeleteCustomerSuperAdmin(data, external));
    try {
      const response = await deleteMethodWithToken(
        url.deleteCustomerSuperAdmin + external?.id + '/'
      );
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchDeleteCustomerSuperAdminSuccess(response.data));

        if (external && external.redirect === true) {
          external.redirectNavigate(external.path);
        } else if (external && external.run === true) {
          external.handleFunction(response);
        } else if (external && external.step) {
          external.handleStep(external.step);
        }
      } else if (response.status === 401) {
        ClearTokenRedirectLogin(external?.navigate);
      } else {
        dispatch(fetchDeleteCustomerSuperAdminFailure('Error'));
        if (external && external.toast) {
          external.handleToastError(response);
        }
      }
    } catch (error) {
      dispatch(fetchDeleteCustomerSuperAdminFailure(error.message));
    }
  };
};
